<template>
    <section class="view">
        <div class="view-title">
            Часто задаваемые вопросы
        </div>
        <div class="question-container">
            <div class="question" v-for="item in questions" :key="item.id">
                <div class="icon-container">
                    “
                </div>
                <div class="text-container">
                    <span class="question-title">Вопрос от <span v-if="item.person_type == 0">студента</span> <span v-if="item.person_type == 1">преподавателя</span>: </span>
                    <div class="question-text">"<span v-html="item.question"></span>"</div>
                    <span class="question-title">Ответ </span>
                    <div class="question-text">"<span v-html="item.answer"></span>"</div>
                </div>

            </div>
        </div>

    </section>
</template>

<script>
    import {HTTP} from "../axios";

    export default {
        name: "FAQ",
        data(){
            return{
                questions: []
            }
        },
        methods:{
            update(){
                HTTP
                    .get("FAQ")
                    .then(r=> {
                        this.questions = r.data.FAQ
                    })
            }
        },
        mounted(){
            this.update()
        }
    }
</script>

<style scoped>
    .view-title{
        font-size: 40px;
        color: #18224b;
        line-height: 1.23;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        padding: 20px 0 60px 0;
    }

    .question{
        background: #ededed;
        position: relative;
        padding: 70px 90px 63px 90px;
        box-sizing: border-box;
        width: 650px;
        max-width: 960px;
        margin: 30px auto;
        text-align: left;
        display: flex;
    }

    .icon-container{
        position: absolute;
        color: #c4c4c4;
        left: 47px;
        top: 36px;
        font-family: Arial;
        font-size: 114px;
        line-height: 1;
    }

    .question-title{
        font-weight: 700;
        font-size: 22px;
        line-height: 1.55;
        font-family: 'PT Sans',Arial,sans-serif;
        color: #000;
    }

    .question-text{
        margin-bottom: 24px;
        font-size: 22px;
        line-height: 1.55;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 400;
        color: #000;
    }


</style>